module.exports = __webpack_public_path__ + "assets/img/1_1035.dbb8fc53.jpg";